import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import gallery18 from "../../../assets/farm/img_4.jpg";

const Details = () => {
  return (
    <Box margin={{ xs: "25% 0% 10% 0%", sm: "5% 0% 2% 0%" }}>
      <Typography
        variant="h3"
        color="#00AEEF"
        fontWeight={900}
        paddingBottom={"3%"}
        textAlign={"left"}
      >
        Farm Services
      </Typography>
      <Box
        width={"100%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "42%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          paddingRight={{ xs: "0%", sm: "2%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            Fish Shoal Nigeria is the commercial arm of our organization. At the
            moment, Fish Shoal Nigeria operates the following:
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={700}
            textAlign={"left"}
            paddingTop={"4%"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            Commercial Farm (Catfish and Tilapia Fish Seeds, Catfish and Tilapia
            Table Fish):
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>
            Catfish Fingerlings (5.4 Million Capacity per Annum)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>
            Tilapia Fingerlings (130 Million Capacity per Annum)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={700}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"4%"}
            lineHeight={"1.625em"}
          >
            Demonstration Farm (Fish Processing, Ornamentals Fish Farm):
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>{" "}
            Ornamental Fish Farm (14 Fish Species, 5,000 Capacity per Annum)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10070;{" "}
            </Typography>{" "}
            Fish Processing Demonstration (2.1 Tons Dry Weight Capacity per
            Annum)
          </Typography>
        </Box>
        <Box
          width={{ xs: "100%", sm: "55%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          marginTop={{ xs: "10%", sm: "0%" }}
        >
          <Box
            component="img"
            height={{ xs: "27vh", sm: "400px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={gallery18}
            alt={"farm-services-img"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Details;
